import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export const useDeleteDocument = () => {
  const [state, execute, cancel] = axios<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (documentId: ObjectId) => {
      return execute({
        url: `/${documentId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
